import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EpSelfEnrolmentAboutFormGroup } from '../../forms/ep-self-enrolment-about-form-group';

@Component({
  selector: 'app-ep-self-enrolment-about',
  templateUrl: './ep-self-enrolment-about.component.html',
  styleUrls: ['./ep-self-enrolment-about.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpSelfEnrolmentAboutComponent {
  @Input({ required: true }) form!: EpSelfEnrolmentAboutFormGroup;
  @Input() formSubmitted: boolean = false;

  public maskitoOptions = {
    name: {
      mask: /^.{0,60}$/
    },
    shortName: {
      mask: /^.{0,50}$/
    },
    craPayrollRemittanceAccountNumber: {
      mask: /^\d{0,9}$/
    }
  };

  public customErrorMessages = {
    name: {
      required: $localize`Organization Name required`
    },
    shortName: {
      required: $localize`Organization Short Name required`
    }
  };
}
